module.exports = __webpack_public_path__ + "img/icon-ny-2.4a9d5049.svg";